const {
	DomClass, setType, isa, getNodes,
	MouseCoords, NodeBox,
	MainLoop,
	on, onready,
	trackEvent,
	InstallLink,
	Game
} = require('/src/lib/shooty-ship/game');